<template>
  <div>
    <div class="main-list-container">
      <div class="col-12">
        <h1 class="page-title">Services</h1>
      </div>

      <div class="col-12 row list-container-row">
        <div class="col-12 pull-left no-gutters list-container-item list-container-item-right">
          <div class="list-container">
            <div v-if="this.items.length > 0">
              <div class="row">
                <div class="col-12 col-md-6 card-holder" v-for="(item, index) in this.items" :key="index">
                  <div class="card">
                    <div class="card-header bold">{{ item.title }}</div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <span class="event-date">{{ item.starts | dateFilterFormatUKEventDisplay }}</span>
                        </div>
                        <div class="col-12">
                          <span class="event-time">{{ item.starts | timeFilter }} - {{ item.ends | timeFilter }}</span>
                        </div>
                      </div>
                      <div class="card-text">
                        <div class="desc">{{ item.shortDescription }}</div>
                        <br />

                        <div class="disclaimer" v-if="item.disclaimer !== null && item.disclaimer.length > 0">{{ item.disclaimer }}</div>
                      </div>
                      <div class="event-button-holder">
                        <a v-on:click="viewSeats($event, item)" class="btn btn-primary href-btn">Reserve your seat</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.items.length === null || this.items.length === 0">
              <h3>No upcoming services</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventsService } from "@/services/ApiService";
import dateFilter from "@/filters/dateFilter";
import dateFilterFormatUKEventDisplay from "@/filters/dateFilterFormatUKEventDisplay";
import timeFilter from "@/filters/timeFilter";

export default {
  name: "Home",
  filters: { dateFilter, timeFilter, dateFilterFormatUKEventDisplay },
  data() {
    return {
      items: []
    };
  },
  methods: {
    async getAll() {
      var response = await EventsService.getAll();
      if (typeof response !== "undefined" && response.success) {
        this.items = response.data;
      }
    },
    viewSeats(event, selected) {
      if (typeof selected !== "undefined" && selected !== null) {
        sessionStorage.setItem("selected.event", JSON.stringify(selected));
        this.$router.push({ path: "/view-seats/" + selected.id });
      }
    }
  },
  created() {
    this.getAll();
  }
};
</script>

<style scoped>
</style>